import React from 'react'

const TimeMarkers = () => (
  <div className='timeMarkers'>
    {Array.from({ length: 48 }).map((time, i) => {
      const label = `${(i / 2) % 12 || 12} ${i / 2 >= 12 ? 'PM' : 'AM'}`
      return <p key={`timeMarker-${i}`}>{label}</p>
    })}
  </div>
)

export default TimeMarkers
